import React, {useState, useEffect} from "react";

import "./VersionInfo.css";
import {Accordion, Button, Spinner} from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import {faAddressCard} from "@fortawesome/free-regular-svg-icons";
import {faRefresh} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import RebootButton from "../../Partials/RebootButton/RebootButton";
import FactoryResetButton from "../../Partials/FactoryResetButton/FactoryResetButton";
import FirmwareUpdate from "../FirmwareUpdate/FirmwareUpdate";

function VersionInfo({versionData, bond}) {
    const [currentVersionData, setCurrentVersionData] = useState(versionData);
    const [refreshing, setRefreshing] = useState(false);

    useEffect(() => {
        setCurrentVersionData(versionData);
    }, [versionData]);

    async function refreshVersionData() {
        setRefreshing(true);
        try {
            const response = await bond.get('/sys/version');
            setCurrentVersionData(response);
        } catch (error) {
            console.error('Error refreshing version data:', error);
        } finally {
            setRefreshing(false);
        }
    }

    function renderVersionData() {
        let elements = [];
        for (let [key, value] of Object.entries(currentVersionData)) {
            if (key[0] === "_") continue;
            elements.push(
                <FloatingLabel label={key} className="mb-2" key={"version" + key}>
                    <Form.Control type="text" readOnly={true} placeholder="0" value={value || ""}/>
                </FloatingLabel>
            );
        }
        return elements;
    }

    return (currentVersionData ? <Accordion className="livelogAccordionVersion">
        <Accordion.Item eventKey="0">
            <Accordion.Header>
                <FontAwesomeIcon icon={faAddressCard} size="xl"
                                 className="iconAccordionHeader"/>Version: {currentVersionData.fw_ver}
            </Accordion.Header>
            <Accordion.Body>
                <div className="d-grid gap-2 mb-3">
                    <Button
                        variant="primary"
                        onClick={refreshVersionData}
                        disabled={refreshing}
                    >
                        {refreshing ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    className="me-2"
                                />
                                Refreshing...
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faRefresh} className="me-2" />
                                Refresh Version Info
                            </>
                        )}
                    </Button>
                </div>

                <RebootButton bond={bond}/>
                <FactoryResetButton bond={bond}/>
                <FirmwareUpdate bond={bond} target={currentVersionData.target} onUpgradeComplete={refreshVersionData} />

                <hr className="my-3" />

                {renderVersionData()}
            </Accordion.Body>
        </Accordion.Item>
    </Accordion> : <></>)
}

export default VersionInfo;


